import axios from "axios";
import React, { useState, useEffect } from "react";
import {databaseUrl} from "../../server/server";
//material ui
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';


import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../server/axios";


let access = localStorage.getItem("accesstoken");

const Orderboards_select_car = () => {

const location = useLocation(); // 추가된 부분
const datasss = location.state?.data; // 추가된 부분
const navigate = useNavigate();


const [user_car, set_User_car] = React.useState('');

const handleChange = (user,event) => {
  set_User_car(event.target.value);
  const indexUserList = visitor.map( (user) => user[1]);
  const indexUser = indexUserList.indexOf(user);
  visitor[indexUser][2] = event.target.value;
};
//const params = new URLSearchParams(window.location.search);
//let visitday = params.get("visitday");
const [visitor, setVisitor] = useState([]);
const [car, setCar] = useState([]);
    useEffect(() => {
        axios.get(`${databaseUrl}/orderboard/car?visitday=${datasss}`,{
            headers: {Authorization:`Bearer ${access}`},
        }
        ).then((response)=>{
            const car_name = []
            const car_user_list = [];
            const car_info_list = [];
            for(let i = 0; i < response.data[0].length; i++){
                car_name.push(response.data[0][i].car_name);

              const text = response.data[0][i].car_user ?? 'N';
                if(text.length > 2){
                  car_user_list.push(response.data[0][i].car_user);
                  car_info_list.push(response.data[0][i].car_name);
                }
            }
            setCar([...car_name]);

            const visitorArr = [];
            for(let i = 0; i < response.data[1].length; i++){
              const indexNumber = car_user_list.indexOf(response.data[1][i].name);
              if( indexNumber !== -1 ){
                const user_car = car_info_list[indexNumber]
                visitorArr.push([response.data[1][i].id,response.data[1][i].name,user_car]);
                continue;
              } 
              visitorArr.push([response.data[1][i].id,response.data[1][i].name,'담당차없음']);
            }
            setVisitor([...visitorArr]);
        })
    }, [])

  const handleSubmit = (event) => {
    event.preventDefault();

    console.log(visitor);

    const user_car_list = [];
    for(let i = 0; i < visitor.length; i++){
      user_car_list.push({
        id:visitor[i][0],
        car:visitor[i][2]
      })
    }

    axios.post(`${databaseUrl}/orderboard/car`,user_car_list,{
      headers: {Authorization:`Bearer ${access}`}
    }).then((response)=>{
      navigate( '/Orderboards', { state: {visitday:datasss} } )
    })

  }
  return (
    <div className="select_visitor">
    <form onSubmit={handleSubmit}>
      <table>
        <thead>
          <tr>
            <td colSpan={2}><h1> Select Car {datasss}</h1></td>
          </tr>
        </thead>
        <tbody>
      {visitor.map((value)=>
        <tr key={value[0]}>
          <td>{value[1]}</td>
          <td>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel variant="standard" htmlFor="uncontrolled-native">Car Select {value[1]}</InputLabel>
        <NativeSelect
          defaultValue={value[2]}
          labelid="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          onChange={(e)=>handleChange(value[1],e)}
          label="select-car"
        >
          <option value="없음">없음</option>
          {car.map((val)=>
          <option value={val}>{val}</option>
           )
          }
        </NativeSelect>
      </FormControl>
      </td>
        </tr>)
      }
      </tbody>
      <tfoot>
      <tr>
        <td colSpan={2}>
           <input type="submit" value="Submit" className="selectman_submit" />
        </td>
      </tr>
      </tfoot>
      </table>
    </form>
    </div>

  );

}
export default Orderboards_select_car;